<template>
	<div>
		<Titlebar />
		<div class="cards">
			<Card>
				<h2>Competition entries</h2>
				<EventEntriesForm />
			</Card>
		</div>
	</div>
</template>

<script>
import Titlebar from '@/components/Titlebar'
import Card from '@/components/Card'
import EventEntriesForm from '@/forms/EventEntriesForm'

export default {
	name: 'Reporting',
	components: {
		Titlebar,
		Card,
		EventEntriesForm,
	},
}
</script>

<style lang="scss" scoped>
@import '~scss/layout';

.cards {
	@include not-last {
		margin-bottom: 2rem;
	}
}
</style>
